import React from 'react'
import styled from 'styled-components'
import Tooltip from '../../../components/Tooltip'
import Loadout from './Loadout.js'
import * as Options from '../Options.js'
import teamManager from '../teamManager.js'

const TeamGroup = styled.div`
    border: 2px solid;
    border-radius: 4px;
    font-size: 1.1rem;
    font-weight: 400;
    margin: 5px 0;
    padding: 4px;
    background: var(--bg);
`

const TeamName = styled.div`
    font-weight: bold;
    cursor: pointer;
    padding: 5px;
    border-bottom: 1px solid;
    margin-bottom: 5px;
`

const PlayerList = styled.ul`
    list-style-type: none;
    padding: 0;
    margin: 0;
`

const PlayerItem = styled.li`
    margin: 0;
    overflow: hidden;
    cursor: pointer;
    display: grid;
    grid-template-columns: 75px .25fr .25fr .5fr;
    grid-column-gap: 5px;

    i {
        margin-left: 5px;
        font-size: 1.1rem;
        line-height: 0.5rem;
    }
`

const PlayerName = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

const PlayerDatapoint = styled.div`
    text-align: right;
`

class Roster extends React.Component {
    componentDidMount() {
        this.assignTeamIds();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.rosters !== this.props.rosters) {
            teamManager.reset();
            this.assignTeamIds();
        }
    }

    assignTeamIds() {
        const { rosters } = this.props;
        rosters.forEach(team => {
            teamManager.assignTeam(team.names);
        });
    }

    toggleTeamTracking = (team) => {
        const { marks } = this.props;
        team.forEach(playerName => {
            if (marks && marks.toggleTrackedPlayer) {
                marks.toggleTrackedPlayer(playerName);
            }
        });
    }

    handlePlayerClick = (playerName) => {
        const { marks } = this.props;
        if (marks && marks.toggleTrackedPlayer) {
            marks.toggleTrackedPlayer(playerName);
        }
    }

    handlePlayerMouseEnter = (playerName) => {
        const { marks } = this.props;
        if (marks && marks.setHoveredPlayer) {
            marks.setHoveredPlayer(playerName);
        }
    }

    handlePlayerMouseLeave = () => {
        const { marks } = this.props;
        if (marks && marks.setHoveredPlayer) {
            marks.setHoveredPlayer(null);
        }
    }

    renderPlayer = (p) => {
        const teamColor = teamManager.getTeamColor(p.name);
        return (
            <PlayerItem
                key={p.name}
                onClick={() => this.handlePlayerClick(p.name)}
                onMouseEnter={() => this.handlePlayerMouseEnter(p.name)}
                onMouseLeave={this.handlePlayerMouseLeave}
                style={{
                    color: teamColor,
                    textDecoration: this.props.marks.isPlayerTracked(p.name) ? 'underline' : '',
                    opacity: p.health === 0 && p.status === 'dead' ? 0.5 : 1,
                }}
            >
                <Tooltip
                    arrow
                    placement="left"
                    duration={0}
                    theme="pubgsh"
                    html={<Loadout items={p.items} />}
                >
                    <PlayerName>{p.name}</PlayerName>
                </Tooltip>
                <PlayerDatapoint>{p.kills}</PlayerDatapoint>
                <PlayerDatapoint>{p.assists}</PlayerDatapoint>
                <PlayerDatapoint>{Math.round(p.damageDealt)}</PlayerDatapoint>
            </PlayerItem>
        );
    }

    renderTeam = (team, index) => {
        const teamColor = teamManager.getTeamColor(team.names[0]);
        const placement = team.placement;
        const teamName = `Team ${index + 1} - #${placement}`;

        return (
            <TeamGroup key={`roster-${team.names[0]}`} style={{ borderColor: teamColor }}>
                <TeamName
                    onClick={() => this.toggleTeamTracking(team.names)}
                    style={{ color: teamColor }}
                >
                    {teamName}
                </TeamName>
                <PlayerList>
                    {team.names.map(playerName => {
                        const p = this.props.telemetry.players[playerName]
                        if (!p) return null
                        return this.renderPlayer(p)
                    })}
                </PlayerList>
            </TeamGroup>
        )
    }

    render() {
        const { rosters } = this.props;

        if (!rosters) return null;

        return (
            <Options.Context.Consumer>
                {({ options }) => rosters.map(this.renderTeam)}
            </Options.Context.Consumer>
        )
    }
}

export default Roster


// WEBPACK FOOTER //
// src/components/MatchPlayer/Roster/index.js